import { render, staticRenderFns } from "./TopicLink.vue?vue&type=template&id=8c26292c"
import script from "./TopicLink.vue?vue&type=script&lang=js"
export * from "./TopicLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports